import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { CountNewsResponseModel } from './count-news-response.model';
import { NewsModel } from './news.model';
import { SearchNewsModel } from './search-news.model';

const apiUrl = `/api/news`;

export const newsClient = {
  count: (model: SearchNewsModel): Promise<CountNewsResponseModel> => {
    return baseClient.body<SearchNewsModel, CountNewsResponseModel>({
      url: `${apiUrl}/count`,
      method: 'POST',
      body: model,
    });
  },

  search: (model: SearchNewsModel): Promise<ResultListModel<NewsModel>> => {
    return baseClient.body<SearchNewsModel, ResultListModel<NewsModel>>({
      url: `${apiUrl}/search`,
      method: 'POST',
      body: model,
    });
  },

  get: (newsId: string): Promise<NewsModel> => {
    return baseClient.get<NewsModel>(`${apiUrl}/${newsId}`);
  },
};
